import DOMPurify from "dompurify";
export var maybePluralize = function(count, noun) {
    var suffix = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : "s";
    return "".concat(count, " ").concat(noun).concat(count === 1 ? "" : suffix);
};
export var toKebabCase = function(value) {
    var _value_match;
    return (_value_match = value.match(/[A-Z]{2,}(?=[A-Z][a-z]+\d*|\b)|[A-Z]?[a-z]+\d*|[A-Z]|\d+/g)) === null || _value_match === void 0 ? void 0 : _value_match.map(function(x) {
        return x.toLowerCase();
    }).join("-");
};
export var toCamelCase = function(value) {
    return value.replaceAll(/([-_][a-z])/gi, function($1) {
        return $1.toUpperCase().replace("-", "").replace("_", "");
    });
};
export var camelToSnakeCase = function(value) {
    return value.replaceAll(/([a-z])([A-Z])/g, function(_, $1, $2) {
        return "".concat($1, "_").concat($2.toLowerCase());
    });
};
export var toSentenceCase = function(value, toUpperCaseFirstLetter) {
    if (!value) return;
    var string = value.replaceAll(/([-_][a-z])/gi, function($1) {
        return $1.replace("-", " ").replace("_", " ");
    });
    if (toUpperCaseFirstLetter) {
        return string.charAt(0).toUpperCase() + string.slice(1);
    }
    return string;
};
export var mask = function(cc) {
    var num = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 4, mask = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : "*";
    return "".concat(cc).slice(-num).padStart("".concat(cc).length, mask);
};
export var lightMarkdownParser = function(text) {
    var html = text.replaceAll(/\*\*([^*]+)\*\*/gim, "<strong>$1</strong>") // strong text
    .replaceAll(/\*([^*]+)\*/gim, "<em>$1</em>") // emphasized text
    .replaceAll(/\[([^[]+)\](\(([^)]*))\)/gim, '<a href="$3" target="_blank" rel="noopener noreferrer">$1</a>') // anchor tags
    .trim();
    // Sanitize the final HTML output to prevent XSS injection via the input.
    // Uses an allowlist so only the tags/attrs we generate can survive.
    return DOMPurify.sanitize(html, {
        ADD_ATTR: [
            "target"
        ],
        ALLOWED_ATTR: [
            "href",
            "target",
            "rel"
        ],
        ALLOWED_TAGS: [
            "strong",
            "em",
            "a"
        ]
    });
};
export var truncateStringByWord = function(input, maxLength) {
    if (input.length <= maxLength) {
        return input;
    }
    var truncated = input.slice(0, maxLength);
    var lastSpaceIndex = truncated.lastIndexOf(" ");
    if (lastSpaceIndex > 0) {
        truncated = truncated.slice(0, lastSpaceIndex);
    }
    return truncated + "...";
};

//# sourceMappingURL=text.js.map